import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../../../../ui/layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  progress: {
    marginTop: theme.spacing(0.5),
  },
}));
